import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RiCheckboxCircleFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'
import { StyledLoadApplySuccess } from './LoadApplySuccess.style'

interface LoadApplySuccessProps extends LibraryComponentType {
  onAction?: () => void
}

const LoadApplySuccess: FC<LoadApplySuccessProps> = ({ onAction, onClose }) => {
  const { t } = useTranslation()

  const onClick = () => {
    onAction?.()
    onClose?.()
  }

  return (
    <StyledLoadApplySuccess>
      <div>
        <RiCheckboxCircleFill size={64} />
      </div>
      <Text as="h1" fontSize="large" fontWeight="normal" mb={theme.spacing.large} mt={theme.spacing.medium}>
        {`${t('loads.detail.youAppliedThisLoad')}`}
      </Text>
      <Text as="p" fontSize="medium" mb={theme.spacing.large}>
        {`${t('loadApplySuccess.subTitle')}`}
      </Text>
      <Button onClick={onClick}>{`${t('button.ok')}`}</Button>
    </StyledLoadApplySuccess>
  )
}

LoadApplySuccess.defaultProps = {
  onAction: () => null,
}

export default LoadApplySuccess
